import {useModal} from "../../context/ModalContext.tsx";

export const useModalClose = (modalId?: string) => {
    const { closeModal } = useModal();

    return () => {
        if (modalId) {
            closeModal(modalId);
        }
    };
};